import { render } from "./PortfolioView.vue?vue&type=template&id=4bdbceae"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__